import { Modal, Pill } from "components/ui";
import React, { useRef, useEffect } from "react";

interface QRModalProps {
  wine: string;
  content: string;
  onClose: () => void;
}

export function QRModal({ wine, content, onClose }: QRModalProps) {
  const cR = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const s = document.createElement("script");
    s.src = "https://unpkg.com/qrcode@1.5.3/build/qrcode.min.js";
    s.onload = () =>
      (window as any).QRCode?.toCanvas(cR.current, `https://vinai.fr/f/${btoa(wine.slice(0, 28)).replace(/=/g, "")}`, {
        width: 124, margin: 1, color: { dark: "#1a0a06", light: "#ffffff" },
      });
    document.head.appendChild(s);
    return () => { try { document.head.removeChild(s); } catch {} };
  }, [wine]);

  const print = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<html><head><title>VINAI</title><style>@page{size:85mm 55mm;margin:0}*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Helvetica Neue',sans-serif;width:85mm;height:55mm}.c{width:100%;height:100%;padding:5mm;display:flex;gap:4mm;border:0.5px solid #d4c4b0}.l{flex:1;display:flex;flex-direction:column;justify-content:space-between;overflow:hidden}.tg{font-size:5.5px;letter-spacing:2px;text-transform:uppercase;color:#C4824A;margin-bottom:2mm}.wn{font-size:10px;color:#1a0a06;margin-bottom:1mm}.dc{font-size:6px;color:#555;line-height:1.5;font-style:italic}.ft{font-size:4.5px;letter-spacing:2px;color:#ccc;text-transform:uppercase;padding-top:1.5mm;border-top:0.3px solid #eee}.qw{display:flex;flex-direction:column;align-items:center;gap:2mm;flex-shrink:0}.qi{width:27mm;height:27mm}.sc{font-size:4.5px;letter-spacing:1.5px;text-transform:uppercase;color:#999;text-align:center}</style></head><body><div class="c"><div class="l"><div><div class="tg">VINAI · Fiche produit</div><div class="wn">${wine}</div><div class="dc">${content.slice(0, 140)}…</div></div><div class="ft">vinai.fr</div></div><div class="qw"><img class="qi" src="${cR.current?.toDataURL() || ""}"/><div class="sc">Fiche complète</div></div></div></body></html>`);
    w.document.close();
    w.print();
  };

  return (
    <Modal onClose={onClose} title={`Stop-rayon QR · ${wine}`}>
      <div className="flex gap-3 p-3 bg-foreground/[0.02] border border-border rounded-md mb-3">
        <div className="bg-white p-1.5 rounded-sm shrink-0">
          <canvas ref={cR} />
        </div>
        <div className="text-sm text-secondary italic leading-[1.75]">{content.slice(0, 110)}…</div>
      </div>
      <Pill active onClick={print} style={{ width: "100%" }}>Imprimer stop-rayon 85×55 mm</Pill>
    </Modal>
  );
}
